module.exports = __webpack_public_path__ + "img/logo.f46ccd89.jpg";